var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sweet-modal",
    {
      ref: "modal",
      attrs: { "overlay-theme": "light" },
      on: { close: _vm.closeModal }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-md-8 offset-md-2 text-left" }, [
          _c("div", { staticClass: "share-profile-box" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.$t("message.professional.menu.share")))
            ]),
            _vm._v(" "),
            _vm.profile
              ? _c("div", { staticClass: "text-remark" }, [
                  _c("label", [
                    _vm.profileType === "experience"
                      ? _c("span", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.profile.title) +
                              "\n            "
                          )
                        ])
                      : _c("span", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "message.professional.share_profile_remark"
                                )
                              ) +
                              " " +
                              _vm._s(_vm._f("firstName")(_vm.profile.name)) +
                              "\n            "
                          )
                        ])
                  ]),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.in")) +
                      "\n          " +
                      _vm._s(
                        _vm._f("multiLangName")(
                          _vm.globalState.cities[_vm.profile.province_id]
                        )
                      ) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "share-profile-box" }, [
            _c(
              "a",
              {
                staticClass: "text-primary-link",
                attrs: { href: "" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.fbShare.apply(null, arguments)
                  }
                }
              },
              [
                _c("i", { staticClass: "fab fa-facebook social-icon" }),
                _vm._v("Facebook\n        ")
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "share-profile-box" }, [
            _c(
              "a",
              {
                staticClass: "text-primary-link",
                attrs: { href: _vm.twitterShareUrl, target: "_blank" }
              },
              [
                _c("i", { staticClass: "fab fa-twitter social-icon" }),
                _vm._v("Twitter\n        ")
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "share-profile-box" }, [
            _c(
              "a",
              {
                directives: [
                  {
                    name: "clipboard",
                    rawName: "v-clipboard:copy",
                    value: _vm.shareUrl,
                    expression: "shareUrl",
                    arg: "copy"
                  }
                ],
                staticClass: "text-primary-link",
                attrs: { href: "" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.copyLink.apply(null, arguments)
                  }
                }
              },
              [
                _c("i", { staticClass: "fas fa-clipboard social-icon" }),
                _vm._v(_vm._s(_vm.$t(_vm.isCopiedLink)) + "\n        ")
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a2d6732", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a2d6732","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/components/ShareProfileModal.vue
// module id = 1854
// module chunks = 0